import type { CustomerJobMetadataPolicy } from '~/lib/customer-job-metadata';

/**
 * NEP: which fields of each service a customer's post may set (lib/customer-
 * job-metadata.ts), by service id. Every field of every service's schema is
 * listed once, customer or office (customer-job-metadata.test.ts).
 */
export const NEP_CUSTOMER_JOB_METADATA: Record<string, CustomerJobMetadataPolicy> = {
  photos: { customer: ['option', 'virtual_twilight', 'real_twilight', 'community', 'license'], office: [] },
  floorplans: { customer: ['option'], office: [] },
  '3d': { customer: ['option', 'matterport'], office: [] },
  aerial: { customer: ['option', 'community'], office: [] },
  staging: { customer: ['photos'], office: [] },
  // no form sets the shipping speed or the delivery address.
  brochures: { customer: ['option', 'quantity'], office: ['shipping', 'delivery'] },
  // no form sets the postage.
  eddm: { customer: ['quantity', 'option'], office: ['postage'] },
};
